export default {"src":"/_next/static/media/currants.4f38f8ab.svg","height":489,"width":489,"blurWidth":0,"blurHeight":0};